import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";



const vUI_UserGroupChildrenHierarchy_Fields: {[id:string]: ISearchProviderField } =
    {
        WB_AUTHUSR_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'User  WB Id',  columnResourceName: 'colUsrWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
        WB_USRGRP_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'User Group  WB Id',  columnResourceName: 'colUsrGrpWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
        WB_USRGRPH_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'User Group Hierarchy WB Id',  columnResourceName: 'colUsrGrpHWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
       }

const UserGroupChildrenHierarchyProviderBasic: ISearchProvider =
    {
        keyFields: {id:    'WB_USRGRP_ID',
            id_ui: 'WB_USRGRP_ID',
            name:  'WB_USRGRP_ID'},


        searchProviderFields: vUI_UserGroupChildrenHierarchy_Fields,

        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_UserGroup_ChildrenHierarchy',
                    this.searchProviderFields,
                    [])

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {

                        resolve(res)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        }

    }

const UserGroupChildrenHierarchyProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "UserGroupChildrenHierarchyProfileByName" },

    profileFilter: [
        {profileFilterName: 'User Group Id',     searchProviderFieldId: 'WB_USRGRP_ID',   renderOptions: { }},
        {profileFilterName: 'User Id',   searchProviderFieldId: 'WB_AUTHUSR_ID', renderOptions: { }},

    ],  // ISearchFields
    profileDisplayFields: [
        "WB_AUTHUSR_ID",
        "WB_USRGRP_ID",
        "WB_USRGRPH_ID"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: UserGroupChildrenHierarchyProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const UserGroupChildrenHierarchy: ISearch = {
    searchName: "Find User Group Children",
    renderOptions: { ui5ResourceId: "UserGroupChildrenHierarchy"},
    searchProfileIdDefault: "default",
    searchProfiles: [UserGroupChildrenHierarchyProfileByName]
}


export {UserGroupChildrenHierarchy}